module.exports = __webpack_public_path__ + "img/CSS-01.baeaaef4.svg";